module.exports = __webpack_public_path__ + "img/couples-018.463e976e.jpg";